import {NgForm} from '@angular/forms';
import {Component, ElementRef, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {Store} from '@ngxs/store';
import {Logger} from '../../class/helper/logger.class';
import {AuthActions} from '../../models/auth';
import {StorageService} from '../../services/storage/storage.service';
import {firstValueFrom} from 'rxjs';

const KEYBOARDS = {
  backspace: 8,
  arrowLeft: 37,
  arrowRight: 39,
};

@Component({
  selector: 'app-user-register-confirmation',
  templateUrl: './user-register-confirmation.component.html',
  styleUrls: ['./user-register-confirmation.component.scss']
})
export class UserRegisterConfirmationComponent implements OnInit {

  codeFromClipboard = '';
  inputCodeOne: number;
  inputCodeTwo: number;
  inputCodeThree: number;
  inputCodeFour: number;
  isValidate: boolean;
  acceptPermissionClipboard: boolean;
  @Output() alreadyConfirmed: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild('form') form: NgForm;
  @ViewChild('ngInputOne') ngInputOne: ElementRef;
  @ViewChild('ngInputTwo') ngInputTwo: ElementRef;
  @ViewChild('ngInputThree') ngInputThree: ElementRef;
  @ViewChild('ngInputFour') ngInputFour: ElementRef;
  constructor(
    private store: Store,
    private storageService: StorageService
  ) { }

  ngOnInit(): void {
    this.initValuesHttp();
  }

  async initValuesHttp(): Promise<void> {
    try {
      await firstValueFrom((this.store.dispatch(new AuthActions.SendEmailConfirmation())));
    } catch (e) {
      Logger.log('Ocurrio un error', e?.message);
      if (e.message === 'The user already confirmed his email') {
        this.alreadyConfirmed.emit(true);
      }
    }
    // this.checkPermissionClipboard();
  }

  onFocus(e): void {
    setTimeout(() => {
      e.target.select();
    }, 0);
    // this.checkPermissionClipboard();
  }

  checkPermissionClipboard(): void {
    navigator.permissions.query({ name: 'clipboard-read' as PermissionName }).then((result) => {
      if (result.state === 'granted' || result.state === 'prompt') {
        navigator.clipboard.readText().then(text => {
          if (!this.inputCodeOne && !this.inputCodeTwo && !this.inputCodeThree && !this.inputCodeFour) {
            this.codeFromClipboard = '';
          }
          if (this.codeFromClipboard !== text) {
            if (text.length === 4 && Number.isInteger(Number(text))) {
              this.codeFromClipboard = text;
              this.inputCodeOne = Number(this.codeFromClipboard[0]);
              this.inputCodeTwo = Number(this.codeFromClipboard[1]);
              this.inputCodeThree = Number(this.codeFromClipboard[2]);
              this.inputCodeFour = Number(this.codeFromClipboard[3]);
            }
          }
        });
      }
    });
  }

  validate(): void {
    this.isValidate = true;
  }

  getValue(): string {
    return `${this.inputCodeOne}${this.inputCodeTwo}${this.inputCodeThree}${this.inputCodeFour}`;
  }

  handleInput(e): void {
    const input = e.target;
    const nextInput = input.nextElementSibling;
    if (nextInput && input.value) {
      nextInput.focus();
      if (nextInput.value) {
        nextInput.select();
      }
    }
  }

  handlePaste(e): void {
    e.preventDefault();
    const paste = e.clipboardData.getData('text');
    if (!paste) return;
    if (paste.length === 4 && Number.isInteger(Number(paste))) {
      try {
        this.inputCodeOne = Number(paste[0]);
        this.inputCodeTwo = Number(paste[1]);
        this.inputCodeThree = Number(paste[2]);
        this.inputCodeFour = Number(paste[3]);

        this.ngInputOne.nativeElement.value = paste[0] || '';
        this.ngInputTwo.nativeElement.value = paste[1] || '';
        this.ngInputThree.nativeElement.value = paste[2] || '';
        this.ngInputFour.nativeElement.value = paste[3] || '';
      } catch (e) {
        console.log(e);
      }
    }
  }

  handleBackspace(e): void {
    const input = e.target;
    if (input.value) {
      input.value = '';
      return;
    }
    input.previousElementSibling.focus();
  }

  handleArrowLeft(e): void {
    const previousInput = e.target.previousElementSibling;
    if (!previousInput) return;
    previousInput.focus();
  }

  handleArrowRight(e): void {
    const nextInput = e.target.nextElementSibling;
    if (!nextInput) return;
    nextInput.focus();
  }

  handleKeyDown(e): void {
    switch (e.keyCode) {
      case KEYBOARDS.backspace:
        this.handleBackspace(e);
        break
      case KEYBOARDS.arrowLeft:
        this.handleArrowLeft(e);
        break
      case KEYBOARDS.arrowRight:
        this.handleArrowRight(e);
        break
      default:
    }
  }
}
